/* eslint-disable react/require-optimization */

/* eslint-disable react/no-arrow-function-lifecycle */

/* eslint-disable @typescript-eslint/ban-ts-comment */

/* eslint-disable flowtype/no-types-missing-file-annotation */

/* no-flow */
import * as React from 'react'
import { useCallback, useState } from 'react'

// @ts-ignore
import DashboardAlert from '../shared/DashboardAlert'
// @ts-ignore
import type { Ambassador } from './message_types'
// @ts-ignore
import SelectBar from './partials/SelectBar'
// @ts-ignore
import { initTabs, shopTab } from './tabs'
// @ts-ignore
import SummaryTab from './tabs/SummaryTab'

type Props = {
  ambassador: Ambassador
  ambassadorShopPath: string
}

const AmbassadorDashboardSummary = ({
  ambassador,
  ambassadorShopPath
}: Props): JSX.Element => {
  const [alertMessage, setAlertMessage] = useState<string | null>(null)
  const [alertIsError, setAlertIsError] = useState(false)

  const renderAlertMessage = useCallback(
    (alertMessage: string, alertIsError = false): void => {
      setAlertMessage(alertMessage)
      setAlertIsError(alertIsError)
      window.scrollTo(0, 0)
      setTimeout((): void => {
        setAlertMessage(null)
      }, 3000)
    },
    []
  )

  const tabs = initTabs({ preferredLanguage: ambassador.preferred_language })

  return (
    <div className="butternutbox-ambassador-dashboard">
      {/* $FlowFixMe */}
      <DashboardAlert
        message={alertMessage}
        isError={alertIsError}
        shippingCountryCode={ambassador.shipping_country_code}
        preferredLanguage={ambassador.preferred_language}
      />
      <div className={`affiliate-dashboard__${tabs[0].hash}`}>
        <div className="affiliate-dashboard container">
          <SelectBar
            tabs={tabs}
            shopTab={ambassadorShopPath ? shopTab : []}
            ambassadorShopPath={ambassadorShopPath}
            ambassador={ambassador}
            selectedIndex={0}
          />
          <SummaryTab
            ambassador={ambassador}
            ambassadorShopPath={ambassadorShopPath}
            visible
            setAlertMessage={renderAlertMessage}
          />
        </div>
      </div>
    </div>
  )
}

export default AmbassadorDashboardSummary
